// Limits mirror the organization-service user table
export const USER_NAME_MAX_LENGTH = 200;
export const USER_EMAIL_MAX_LENGTH = 250;
